<template>
  <div class="side-bar">
    <div class="title">
      <div class="logo text-center">
        <router-link :to="{ name: 'dashboard' }">
          <img src="@/theme/images/logo.png">
        </router-link>
      </div>
      <div
        v-if="$route.name !== 'dashboard'"
        class="back"
      >
        <a
          href="#"
          @click.prevent="$router.go(-1)"
        ><i class="fa fa-arrow-left" /> Back to previous</a>
      </div>
    </div>
    <div
      v-if="$can.view($store.getters.getAuthUser, 'view-commission-balance')"
      class="featured"
    >
      <router-link
        :to="{ name: 'commission.index' }"
        class="btn btn-featured btn-block"
      >
        Commission: <span>KES {{ $number.format($store.getters.getAuthUser.commision) }}</span>
      </router-link>
    </div>
    <div
      v-if="$can.view($store.getters.getAuthUser, 'view-wallet-balance')"
      class="featured"
    >
      <router-link
        v-if="$store.getters.getAuthUser.role === 'agent'"
        :to="{ name: 'wallet.agent.topup' }"
        class="btn btn-featured btn-block"
      >
        Wallet: <span>KES {{ $number.format($store.getters.getAuthUser.balance) }}</span>
      </router-link>
      <router-link
        v-else
        :to="{ name: 'wallet.topup' }"
        class="btn btn-featured btn-block"
      >
        Wallet
      </router-link>
    </div>
    <div class="menu">
      <ul>
        <li v-if="$can.view($store.getters.getAuthUser, 'list-companies')">
          <router-link :to="{ name: 'companies.index' }">
            <div class="icon">
              <i class="fa fa-circle-o" />
            </div>
            <div class="link">
              <p class="title">
                Manage Companies
              </p>
              <p class="small">
                Track your companies in real time
              </p>
            </div>
          </router-link>
        </li>
        <li v-if="list_bidbonds">
          <router-link :to="{ name: 'bidbonds.index' }">
            <div class="icon">
              <i class="fa fa-check" />
            </div>
            <div class="link">
              <p class="title">
                Bid Bonds
              </p>
              <p class="small">
                Manage Bid Bonds
              </p>
            </div>
          </router-link>
        </li>
        <li
          v-if="list_bidbonds"
          :to="{ name: 'bidbonds.index' }"
        >
          <router-link :to="{ name: 'performance.index' }">
            <div class="icon">
              <i class="fa fa-check" />
            </div>
            <div class="link">
              <p class="title">
                Performance Bonds
              </p>
              <p class="small">
                Manage Performance Bonds
              </p>
            </div>
          </router-link>
        </li>
        <li v-if="list_payments">
          <router-link :to="{ name: 'payments.index' }">
            <div class="icon">
              <i class="fa fa-money" />
            </div>
            <div class="link">
              <p class="title">
                Manage Payments
              </p>
              <p class="small">
                Keep track of your wallet
              </p>
            </div>
          </router-link>
        </li>
        <li v-if="$can.view($store.getters.getAuthUser, 'list-users')">
          <router-link :to="{ name: 'users.index' }">
            <div class="icon">
              <i class="fa fa-users" />
            </div>
            <div class="link">
              <p class="title">
                Manage Users
              </p>
              <p class="small">
                Manage system users
              </p>
            </div>
          </router-link>
        </li>
        <li v-if="$can.view($store.getters.getAuthUser, 'list-agents')">
          <router-link :to="{ name: 'agents.index' }">
            <div class="icon">
              <i class="fa fa-users" />
            </div>
            <div class="link">
              <p class="title">
                Manage Agents
              </p>
              <p class="small">
                Credible Agents
              </p>
            </div>
          </router-link>
        </li>
        <li v-if="list_quotes">
          <router-link :to="{ name: 'quotes.index' }">
            <div class="icon">
              <i class="fa fa-arrow-right" />
            </div>
            <div class="link">
              <p class="title">
                Quotes
              </p>
              <p class="small">
                Quotes Requested
              </p>
            </div>
          </router-link>
        </li>
        <li v-if="$can.view($store.getters.getAuthUser, 'view-banlists')">
          <router-link :to="{ name: 'banlists.index' }">
            <div class="icon">
              <i class="fa fa-ban" />
            </div>
            <div class="link">
              <p class="title">
                Banlists
              </p>
              <p class="small">
                Users & Companies Banlists
              </p>
            </div>
          </router-link>
        </li>
        <!--        <li v-if="$can.view($store.getters.getAuthUser, 'marketing')">-->
        <!--          <router-link :to="{ name: 'marketing' }">-->
        <!--            <div class="icon">-->
        <!--              <i class="fa fa-arrow-right" />-->
        <!--            </div>-->
        <!--            <div class="link">-->
        <!--              <p class="title">-->
        <!--                Marketing-->
        <!--              </p>-->
        <!--              <p class="small">-->
        <!--                Send messages to users.-->
        <!--              </p>-->
        <!--            </div>-->
        <!--          </router-link>-->
        <!--        </li>-->
        <li v-if="$can.view($store.getters.getAuthUser, 'list-reports')">
          <router-link :to="{ name: 'reports' }">
            <div class="icon">
              <i class="fa fa-bar-chart" />
            </div>
            <div class="link">
              <p class="title">
                Reports center
              </p>
              <p class="small">
                Generate reports
              </p>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="options">
      <hr class="bg-white">
      <ul>
        <li v-if="$can.view($store.getters.getAuthUser, 'manage-settings')">
          <router-link :to="{ name: 'settings' }">
            <i class="fa fa-cog" />System Settings
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'whats-new' }">
            <i class="fa fa-question" />Whats new?
          </router-link>
        </li>
      </ul>
    </div>
    <div class="buttons pb-5 mb-5">
      <router-link
        :to="{ name: 'whats-new' }"
        class="btn btn-sidebar"
      >
        STATUS
      </router-link>
      <router-link
        :to="{ name: 'privacy' }"
        class="btn btn-sidebar"
      >
        PRIVACY
      </router-link>
      <router-link
        :to="{ name: 'terms' }"
        class="btn btn-sidebar"
      >
        TERMS
      </router-link>
    </div>
    <div class="p-2" />
  </div>
</template>

<script>
export default {
  computed: {
    list_bidbonds() {
      return this.$can.view(this.$store.getters.getAuthUser, 'list-companies') || this.$can.view(this.$store.getters.getAuthUser, 'list-companies-owned')
    },
    list_payments() {
      return this.$can.view(this.$store.getters.getAuthUser, 'list-payments') || this.$can.view(this.$store.getters.getAuthUser, 'list-payments-owned')
    },
    list_quotes() {
      return this.$can.view(this.$store.getters.getAuthUser, 'list-quotes') || this.$can.view(this.$store.getters.getAuthUser, 'list-quotes-owned')
    },
  },

}
</script>
